<template>
  <v-row>
    <v-col cols="12">
      <v-textarea
        label="Enter your answer here"
        v-model="question.value"
        single-line
        outlined
        auto-grow
        :rows="5"
        :rules="[$rules.required]"
        required
        full-width
        @change="saveAnswer"
      ></v-textarea>
      <div v-if="showRequiredError" class="error--text">
        Answer is required
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SurveyQuestionText",
  props: { showRequiredError: { type: Boolean, default: false } },
  data: () => ({}),
  computed: mapGetters({
    question: "survey/current_step",
    is_preview: "survey/is_preview"
  }),
  methods: {
    saveAnswer() {
      if (this.is_preview) {
        return;
      }
      this.$store
        .dispatch("survey/saveSurveyAnswer", {
          id: this.question.id,
          value: this.question.value
        })
        .catch(() => {
          //redirect to error page
        });
    }
  }
};
</script>
